import Dashboard from 'layouts/Dashboard.jsx'

var indexRoutes = [
  { exact: 'true', path: '/dashboard', name: 'Home', component: Dashboard },
  // { path: '/login', name: 'Login', component: LoginPage },
  { path: '/', name: 'Home', component: Dashboard }
]

export default indexRoutes
